'use client'

import Link from 'next/link'
import CookieConsent from 'react-cookie-consent'

export default function CookieConsentBanner() {
  return (
    <>
      <style jsx global>{`
        .cookie-consent-popup > div:last-child {
          display: flex;
          flex-direction: column-reverse;
          gap: 10px;
          width: 100%;
        }
      `}</style>
      <CookieConsent
        location="bottom"
        buttonText="Aceitar"
        declineButtonText="Recusar"
        enableDeclineButton
        cookieName="fameesp-cookie-consent"
        containerClasses="cookie-consent-popup"
        style={{
          background: '#06476d',
          position: 'fixed',
          bottom: '30px',
          left: '20px',
          width: '350px',
          maxWidth: 'calc(100vw - 40px)',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
          marginBottom: '20px',
        }}
        buttonStyle={{
          background: '#f1d600',
          color: '#06476d',
          fontSize: '14px',
          fontWeight: 'bold',
          borderRadius: '6px',
          padding: '10px 20px',
          border: 'none',
          cursor: 'pointer',
          flex: '1',
          margin: 0,
        }}
        declineButtonStyle={{
          background: 'transparent',
          color: '#ffffff',
          fontSize: '14px',
          border: '1px solid #ffffff',
          borderRadius: '6px',
          padding: '10px 20px',
          cursor: 'pointer',
          flex: '1',
          margin: 0,
        }}
        buttonWrapperClasses="cookie-buttons-wrapper"
        contentStyle={{
          margin: 0,
          flex: 'initial',
        }}
        expires={365}
      >
        <div style={{ fontSize: '18px', lineHeight: '1.5' }}>
          Este site usa cookies para melhorar a experiência do usuário e para
          análise de tráfego.{' '} Ao continuar navegando, você concorda com o uso de
          cookies.
          {'  '}
          <Link
            href="/lgpd"
            style={{ color: '#f1d600', textDecoration: 'underline' }}
          >
            Saiba mais
          </Link>
        </div>
      </CookieConsent>
    </>
  )
}
